import { ThrowStmt } from '@angular/compiler';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateRangeEditViewModel, DateRangeOptions, DialogConfirmOptions, EditableContent, EditMetadata } from '../../src';
import * as moment from 'moment';

@Component({
    selector: 'cl-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: ['date-range.component.scss']
})
export class DateRangeComponent implements OnInit {
    static $name: string = 'clDateRange';
    dateRangeEdit: DateRangeEditViewModel;

    range = new FormGroup({
        start: new FormControl('', [Validators.required]),
        end: new FormControl('',[Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<DateRangeComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DateRangeOptions,
    ) {
    }

    ngOnInit(): void {
        this.range.setValue({'start': moment(this.data.startDate), 'end':  moment(this.data.endDate)});
    }

    public confirmAction() {
        this.dialogRef.close(this.getFormatedReturnValue());
    }

    public cancelAction() {
        this.dialogRef.close();
    }

    private getFormatedReturnValue() {
        return { startDate: this.range.value.start.valueOf(), endDate: this.range.value.end.valueOf() };
    }
}